var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26",
    width: 50,
    height: 50,
    rx: 2,
    fill: "#3498DB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "file"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.0491 20.5776H18.2831C18.0012 20.5776 17.7725 20.8061 17.7725 21.0887C17.7725 21.3714 18.0012 21.5999 18.2831 21.5999H31.0491C31.3309 21.5999 31.5597 21.3714 31.5597 21.0887C31.5597 20.8061 31.3309 20.5776 31.0491 20.5776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.2831 17.511H23.3895C23.6714 17.511 23.9001 17.2825 23.9001 16.9999C23.9001 16.7172 23.6714 16.4888 23.3895 16.4888H18.2831C18.0012 16.4888 17.7725 16.7172 17.7725 16.9999C17.7725 17.2825 18.0012 17.511 18.2831 17.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.0491 24.6665H18.2831C18.0012 24.6665 17.7725 24.895 17.7725 25.1776C17.7725 25.4603 18.0012 25.6887 18.2831 25.6887H31.0491C31.3309 25.6887 31.5597 25.4603 31.5597 25.1776C31.5597 24.895 31.3309 24.6665 31.0491 24.6665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M31.0491 28.7554H18.2831C18.0012 28.7554 17.7725 28.9838 17.7725 29.2665C17.7725 29.5491 18.0012 29.7776 18.2831 29.7776H31.0491C31.3309 29.7776 31.5597 29.5491 31.5597 29.2665C31.5597 28.9838 31.3309 28.7554 31.0491 28.7554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.0491 32.8442H18.2831C18.0012 32.8442 17.7725 33.0727 17.7725 33.3553C17.7725 33.638 18.0012 33.8665 18.2831 33.8665H31.0491C31.3309 33.8665 31.5597 33.638 31.5597 33.3553C31.5597 33.0727 31.3309 32.8442 31.0491 32.8442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M29.2188 9.3335H12.667V40.0002H36.667V16.7886L29.2188 9.3335ZM29.5181 11.0784L34.9237 16.4891H29.5181V11.0784ZM13.6883 38.9779V10.3557H28.4968V17.5113H35.6457V38.9779H13.6883Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.d283b7f7.svg";
export { ForwardRef as ReactComponent };